import { fabric } from 'fabric';
import { CanvasDataTypes } from '..';

/**
 * Get only permanent objects from an array of objects
 * @param objects Array of fabric objects
 * @returns Array of permanent objects
 */

export const getPermanentObjects = (objects: fabric.Object[]): fabric.Object[] =>
  objects.filter((object) => {
    const { data, clipPath } = object;
    // Filter canvas objects where:
    const isDataTypeUndefined = !data || !data.type;
    const isUserImage = clipPath && data?.type === CanvasDataTypes.UserImage;
    const isUserText = clipPath && data?.type === CanvasDataTypes.UserText;
    const isNotUserAdded =
      data?.type !== CanvasDataTypes.PhotoZoneImage &&
      data?.type !== CanvasDataTypes.UserText &&
      data?.type !== CanvasDataTypes.UserImage;

    const isPermanentObject = isDataTypeUndefined || isUserImage || isUserText || isNotUserAdded;
    return isPermanentObject;
  });
